<template>
    <div class="mt-16">
        <v-row justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-form @submit.prevent="submitForm">
                    <v-alert
                        v-if="error"
                        class="mb-4"
                        density="comfortable"
                        type="error"
                        variant="tonal"
                    >
                        {{ error }}
                    </v-alert>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Username" v-model="username" required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Password" type="password" v-model="password" required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                ref="authenticatorCodeField"
                                :model-value="authenticatorCode"
                                @update:modelValue="authenticatorCode = normalizeAuthenticatorCode($event)"
                                :label="requiresAuthenticatorCode ? 'Authenticator Code' : 'Authenticator Code (optional)'"
                                maxlength="6"
                                :counter="6"
                                inputmode="numeric"
                                hint="Use the 6-digit code from your authenticator app if MFA is enabled."
                                persistent-hint
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-btn type="submit" :loading="isSubmitting">
                        {{ requiresAuthenticatorCode ? 'Verify & Login' : 'Login' }}
                    </v-btn>
                </v-form>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import { getApiErrorMessage } from '../utils/api';
import { persistAuthSession } from '../utils/authSession';

export default {
    name: 'LoginPage',
    data() {
        return {
            username: '',
            password: '',
            authenticatorCode: '',
            requiresAuthenticatorCode: false,
            isSubmitting: false,
            error: null,
        };
    },
    created() {
        if (localStorage.getItem('token')) {
            this.$router.push('/')
        }
    },
    watch: {
        username() {
            if (this.requiresAuthenticatorCode) {
                this.requiresAuthenticatorCode = false;
                this.authenticatorCode = '';
            }
        },
        password() {
            if (this.requiresAuthenticatorCode) {
                this.requiresAuthenticatorCode = false;
                this.authenticatorCode = '';
            }
        },
    },
    methods: {
        normalizeAuthenticatorCode(value) {
            return String(value || '').replace(/\D/g, '').slice(0, 6);
        },
        async submitForm() {
            this.error = null;
            this.isSubmitting = true;

            try {
                const payload = {
                    username: this.username,
                    password: this.password,
                };

                if (this.authenticatorCode) {
                    payload.authenticatorCode = this.authenticatorCode;
                }

                const response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/user/login', {
                    ...payload,
                }, {
                    skipAuthRedirect: true,
                });
                // check status code
                if (response.status === 200) {
                    persistAuthSession(response.data);
                    this.$store.commit('setLoggedIn', true)
                    this.$router.push('/');
                }
            } catch (error) {
                if (error.response?.status === 401 && error.response?.data?.mfaRequired) {
                    this.requiresAuthenticatorCode = true;
                    this.error = error.response.data.message || 'Authenticator code is required.';
                    await this.$nextTick();
                    this.$refs.authenticatorCodeField?.focus();
                } else {
                    this.error = getApiErrorMessage(error, 'Login failed.');
                }
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};
</script>
